import { useCallback, useRef } from 'react';
import { useRouter } from 'next/navigation';
import useLocationMock from './useLocationMock';
const useHistoryMock = () => {
  const history = useRef({});
  const location = useLocationMock();
  history.current.location = location;
  const {
    pathname
  } = location || {};
  const {
    back,
    push,
    replace
  } = useRouter();
  history.current.back = back;
  history.current.push = push;

  // Add goBack function - equivalent to window.history.back() in React Router v5
  history.current.goBack = back;
  const replaceMock = useCallback((newLocation, options = {}) => {
    if (!newLocation) {
      return;
    }

    // React Router v5 history.replace() never scrolls to the top of the
    // page, but Next.js router.replace() scrolls by default.  Default to
    // scroll: false to match React Router v5 semantics. Callers can still
    // opt-in via { scroll: true } when explicit scrolling is desired.
    const replaceOptions = {
      scroll: options.scroll ?? false
    };
    if (typeof newLocation === 'string') {
      replace(newLocation, replaceOptions);
    } else {
      const {
        pathname: newPathname,
        search
      } = newLocation;
      const searchWithPrefix = search && !search?.startsWith('?') ? '?' + search : search ?? '';
      replace(`${newPathname ?? pathname ?? ''}${searchWithPrefix}`, replaceOptions);
    }
  }, [pathname, replace]);
  history.current.replace = replaceMock;
  const listen = useCallback(callbackFn => {
    'use client';

    const hash = window?.location?.hash;
    window.onhashchange = () => {
      if (!hash) {
        callbackFn();
      }
    };
  }, []);
  history.current.listen = listen;
  return history.current;
};
export default useHistoryMock;